export const wizardTranslation = {
  welcome: {
    title: 'wizard-welcome-title',
    description: 'wizard-welcome-description',
    content: 'wizard-welcome-content',
  },
  navigation: {
    cancel: 'wizard-navigations-cancel',
    back: 'wizard-navigations-back',
    complete: 'wizard-navigations-complete',
  },
}
